import { render, staticRenderFns } from "./qualityControlForm.vue?vue&type=template&id=239cc541&scoped=true"
import script from "./qualityControlForm.vue?vue&type=script&lang=js"
export * from "./qualityControlForm.vue?vue&type=script&lang=js"
import style0 from "./qualityControlForm.vue?vue&type=style&index=0&id=239cc541&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239cc541",
  null
  
)

export default component.exports